import { launchBlocker } from './selection';

/**
 * The launch dialog's words and its submit rule, as plain data.
 *
 * Three things must all be true to submit, and each is the operator's own
 * statement rather than a default: how many (the count, within the cap), why
 * (a reason, which the runner stamps on every run it starts), and that they
 * mean it (the typed phrase the release turn-off already uses).
 */

export const MAX_REASON = 500;

function clients(count: number): string {
    return `${count.toLocaleString('en-US')} ${count === 1 ? 'client' : 'clients'}`;
}

export interface LaunchConfirmView {
    readonly title: string;
    readonly sentence: string;
    readonly confirmLabel: string;
}

export function launchConfirmView(input: {
    readonly count: number;
    readonly moduleTitle: string;
    readonly environment: string;
}): LaunchConfirmView {
    return {
        title: `Migrate ${input.moduleTitle} for ${clients(input.count)}`,
        sentence:
            `This starts a ${input.moduleTitle} migration from Salesforce into V2 for ` +
            `${clients(input.count)} in ${input.environment}. It writes V2 data for each ` +
            'of them and cannot be undone from here.',
        confirmLabel: `Migrate ${clients(input.count)}`,
    };
}

/** Why the dialog cannot submit yet, or `null` when it can. */
export function launchSubmitBlocker(input: {
    readonly count: number;
    readonly reason: string;
    readonly phraseMatches: boolean;
}): string | null {
    const count = launchBlocker(input.count);
    if (count) return count;
    const reason = input.reason.trim();
    if (reason.length === 0) return 'Say why — it is recorded on every run this starts.';
    if (reason.length > MAX_REASON) return `At most ${String(MAX_REASON)} characters.`;
    if (!input.phraseMatches) return 'Type the phrase to confirm.';
    return null;
}
